var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Cargo Booking"
    }
  }, [_c('div', [(_vm.showFlm) ? _c('Cargobooking') : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "FLM"
    }
  }, [_c('div', [(_vm.showFlm) ? _c('FLMConfig') : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Client Management"
    }
  }, [_c('div', [(_vm.showFlm) ? _c('clientmanagement') : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Cron & Central DB"
    }
  }, [_c('div', [(_vm.showFlm) ? _c('Croncentraldb') : _vm._e()], 1)]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Redis"
    }
  }, [_c('div', [(_vm.showFlm) ? _c('redis') : _vm._e()], 1)])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0875e690","hasScoped":true}!./src/modules/adminsettings/views/configuration/configuration.component.html
// module id = 2031
// module chunks = 3